import { render } from "./StockParts.vue?vue&type=template&id=0e6050b8"
import script from "./StockParts.vue?vue&type=script&lang=js"
export * from "./StockParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__